import type { SanityImageObject } from '@sanity/image-url/lib/types/types';
import { z } from 'zod';
import type { ImageWithAlt } from '~/types/sanity-typegen';

/**
 * Schema for validating the required properties of a Sanity Image Object.
 */
const ImageSourceSchema = z.object({
  asset: z.object({
    _ref: z.string(),
  }),
  crop: z
    .object({
      _type: z.literal('sanity.imageCrop'),
      bottom: z.number(),
      left: z.number(),
      right: z.number(),
      top: z.number(),
    })
    .optional(),
  hotspot: z
    .object({
      _type: z.literal('sanity.imageHotspot'),
      height: z.number(),
      width: z.number(),
      x: z.number(),
      y: z.number(),
    })
    .optional(),
  _type: z.string(),
});

/**
 * Parse a Sanity Image Object with optional properties into required
 * properties. This ensures it can be used with the Sanity `imageUrlBuilder`.
 */
export const parseSanityImageObject = (imageObject: ImageWithAlt): SanityImageObject | undefined => {
  const { data, success } = ImageSourceSchema.safeParse(imageObject);

  return success ? data : undefined;
};
